import { add } from 'date-fns';

export const expiryTimeOptions = [
  { value: add(new Date(), { months: 3 }), label: '3 months' },
  { value: add(new Date(), { months: 6 }), label: '6 months' },
  { value: add(new Date(), { months: 9 }), label: '9 months' },
  { value: add(new Date(), { months: 12 }), label: '12 months' },
];

export const testExpiryTimeOptions = [
  { value: add(new Date(), { minutes: 15 }), label: '15 minutes' },
  { value: add(new Date(), { seconds: 5 }), label: '5 seconds' },
  { value: add(new Date(), { seconds: 10 }), label: '10 seconds' },
];
